import { VideoSource, getVideoSource, sanitizeUrl } from '~/components/VideoPlayer/VideoPlayer.utils';
export { VideoSource, getVideoSource, sanitizeUrl };
export const isUrlValid = (videoLink)=>{
    try {
        const parsedVideoLink = new URL(videoLink);
        return getVideoSource(parsedVideoLink) !== VideoSource.Unsupported;
    } catch (err) {
        return false;
    }
};
